import React, { useState } from 'react';
import axios from 'axios';
import toast from 'react-hot-toast';
import { Card, CardContent, Typography, Button, TextField, CircularProgress, InputAdornment, IconButton, Grid } from '@mui/material';
import { handleUnauthorized } from '../../TokenAuth/auth';
import PageHeader1 from '../../components/common/PageHeader1';

function AdminConfig() {
    const [loading, setLoading] = useState(false);
    const [oldPassword, setOldPassword] = useState('');
    const [newPassword, setNewPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');

    const [showOldPassword, setShowOldPassword] = useState(false);
    const [showNewPassword, setShowNewPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);

    const token = localStorage.getItem("astroVani-admin-token");
    const baseUrl = process.env.REACT_APP_BASEURL;

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!oldPassword || !newPassword || !confirmPassword) {
            toast.error("All fields are required.");
            return;
        }

        if (newPassword !== confirmPassword) {
            toast.error("New Password and Confirm Password do not match.");
            return;
        }

        try {
            setLoading(true);
            const response = await axios.post(`${baseUrl}/admin/changePassword`,
                {
                    oldPassword,
                    newPassword,
                    confirmPassword
                },
                {
                    headers: {
                        'Authorization': token,
                        'Content-Type': 'application/json',
                    }
                }
            );

            if (response.data.success || response.status === 200) {
                toast.success(response.data.message || "Password changed successfully");
                setOldPassword('');
                setNewPassword('');
                setConfirmPassword('');
            } else {
                toast.error(response.data.message || "Failed to change password");
            }
        } catch (error) {
            if (error.response?.status === 401) {
                handleUnauthorized();
            } else {
                console.error(`Error changing password:`, error);
                toast.error(error.response?.data?.message || "Error changing password");
            }
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="body d-flex">
            <div className="container-xxl">
                <PageHeader1 pagetitle="Admin Configuration" />
                <Card>
                    <CardContent>
                        <Typography variant="h6" gutterBottom>Change Admin Password</Typography>
                        <form onSubmit={handleSubmit}>
                            <Grid container spacing={2}>
                                <Grid item md={4}>
                                    <TextField
                                        fullWidth
                                        label="Old Password"
                                        type={showOldPassword ? "text" : "password"}
                                        variant="outlined"
                                        value={oldPassword}
                                        onChange={(e) => setOldPassword(e.target.value)}
                                        required
                                        InputProps={{
                                            endAdornment: (
                                                <InputAdornment position="end">
                                                    <IconButton onClick={() => setShowOldPassword(!showOldPassword)} edge="end">
                                                        <i className={showOldPassword ? "icofont-eye" : "icofont-eye-blocked"} style={{ fontSize: '20px' }}></i>
                                                    </IconButton>
                                                </InputAdornment>
                                            )
                                        }}
                                    />
                                </Grid>
                                <Grid item md={4}>
                                    <TextField
                                        fullWidth
                                        label="New Password"
                                        type={showNewPassword ? "text" : "password"}
                                        variant="outlined"
                                        value={newPassword}
                                        onChange={(e) => setNewPassword(e.target.value)}
                                        required
                                        InputProps={{
                                            endAdornment: (
                                                <InputAdornment position="end">
                                                    <IconButton onClick={() => setShowNewPassword(!showNewPassword)} edge="end">
                                                        <i className={showNewPassword ? "icofont-eye" : "icofont-eye-blocked"} style={{ fontSize: '20px' }}></i>
                                                    </IconButton>
                                                </InputAdornment>
                                            )
                                        }}
                                    />
                                </Grid>

                                <Grid item md={4}>
                                    <TextField
                                        fullWidth
                                        label="Confirm Password"
                                        type={showConfirmPassword ? "text" : "password"}
                                        variant="outlined"
                                        value={confirmPassword}
                                        onChange={(e) => setConfirmPassword(e.target.value)}
                                        required
                                        InputProps={{
                                            endAdornment: (
                                                <InputAdornment position="end">
                                                    <IconButton onClick={() => setShowConfirmPassword(!showConfirmPassword)} edge="end">
                                                        <i className={showConfirmPassword ? "icofont-eye" : "icofont-eye-blocked"} style={{ fontSize: '20px' }}></i>
                                                    </IconButton>
                                                </InputAdornment>
                                            )
                                        }}
                                    />
                                </Grid>

                                <Grid item md={12} display="flex" justifyContent="end">
                                    <Button
                                        type="submit"
                                        variant="contained"
                                        color="primary"
                                        disabled={loading}
                                        sx={{ mt: 1 }}
                                    >
                                        {loading ? <CircularProgress size={24} color="inherit" /> : 'Change Password'}
                                    </Button>
                                </Grid>
                            </Grid>
                        </form>
                    </CardContent>
                </Card>
            </div>
        </div>
    );
}

export default AdminConfig;
